export default __webpack_public_path__ + "static/media/logo.fb451432.png";